import { styled } from "@pp/lib/ui/theme";

const Box = styled("div", { display: "block" });

export default Box;
